<template>
  <nav>
    <ul class="row">
      <li @click="updateLanguage('de')" :class="['row center', { active: language === 'de' }]">
        DE
      </li>
      <li @click="updateLanguage('en')" :class="['row center', { active: language === 'en' }]">
        EN
      </li>
      <li :style="{ right: language === 'en' ? 0 : '40px' }"></li>
    </ul>
  </nav>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

export default {
  name: 'Language',
  setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const language = computed(() => store.state.language)

    const updateLanguage = (language) => {
      store.commit('setLanguage', language)
      let url = route.fullPath
      let updatedUrl = url.slice(0, 1) + language + url.slice(3)
      router.push(updatedUrl)
    }

    return {
      language,
      updateLanguage,
    }
  },
}
</script>

<style lang="scss" scoped>
ul {
  list-style: none;
  padding: 0;
  position: relative;
  justify-content: flex-end;
  width: 50%;
  margin: -10px 0 0 auto;

  li {
    border-radius: 15px;
    width: 40px;
    height: 35px;
    transition: all linear 0.2s;
    cursor: pointer;

    &.active {
      color: white;
      z-index: 5;
    }

    &:last-of-type {
      position: absolute;
      background-color: var(--dark-10);
    }
  }
}
</style>
